import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { billingRoutesConfig } from 'domains/account/routes';

const billingPageUrl = billingRoutesConfig.billing.generatePath();

export const useRedirectToBilling = () => {
  const navigate = useNavigate();

  const redirectToBilling = useCallback(
    () => navigate(billingPageUrl),
    [navigate],
  );

  return { redirectToBilling };
};
